var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudOrganisation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 22,
    viewBox: "0 0 40 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2979 13.7039C18.8005 13.0662 23.5855 7.08735 27.917 4.73389C25.9565 1.97956 22.7373 0.183105 19.0987 0.183105C14.2901 0.183105 10.2147 3.32164 8.80772 7.66189C12.5778 8.79345 17.6347 13.2644 18.2461 13.8065L18.2979 13.7039Z",
    fill: "url(#cloud_organisation_svg__paint0_linear_1945_697)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.254 13.7601L18.1908 13.7039C17.5795 13.1618 12.5778 8.7935 8.80771 7.66195C8.24193 7.49178 7.70335 7.39441 7.21125 7.39441C3.22888 7.39441 0 10.6233 0 14.6057C0 18.588 3.22888 21.8169 7.21125 21.8169H30.9853C29.3283 21.8169 27.3643 20.924 25.4802 19.7336C21.7039 17.3468 18.2531 13.7609 18.2531 13.7609L18.254 13.7601Z",
    fill: "url(#cloud_organisation_svg__paint1_linear_1945_697)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9862 3.78821C30.0397 3.78821 28.9923 4.14961 27.9169 4.7338C23.5854 7.08726 18.8004 13.0661 18.2978 13.7038C18.2689 13.7398 18.254 13.7599 18.254 13.7599C18.254 13.7599 21.7057 17.3458 25.481 19.7326C27.3643 20.9238 29.3292 21.8159 30.9862 21.8159C31.08 21.8159 31.1739 21.8141 31.2677 21.8115C36.1159 21.6624 40 17.6862 40 12.8021C40 7.91794 35.9641 3.78821 30.9862 3.78821Z",
    fill: "url(#cloud_organisation_svg__paint2_linear_1945_697)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8355 0.35854C22.4653 0.35854 25.6775 2.1471 27.6388 4.89002C27.7318 4.83652 27.8239 4.78389 27.916 4.73389C25.9555 1.97956 22.7363 0.183105 19.0978 0.183105C16.8154 0.183105 14.6996 0.890985 12.9549 2.09798C14.6479 0.998878 16.6663 0.35854 18.8346 0.35854H18.8355Z",
    fill: "url(#cloud_organisation_svg__paint3_linear_1945_697)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94893 7.56984C7.44014 7.56984 7.97873 7.66721 8.54538 7.83738C12.3155 8.96894 17.3171 13.3373 17.9285 13.8794L17.9917 13.9355C17.9917 13.9355 21.4434 17.5214 25.2187 19.9082C26.6064 20.7854 28.0371 21.5003 29.3572 21.816H30.9861C29.3292 21.816 27.3652 20.9231 25.481 19.7327C21.7048 17.346 18.2539 13.7601 18.2539 13.7601L18.1908 13.7039C17.5794 13.1618 12.5778 8.7935 8.80766 7.66195C8.24188 7.49178 7.7033 7.39441 7.2112 7.39441C5.67527 7.39441 4.25249 7.87598 3.08322 8.69438C4.20074 7.98387 5.52527 7.56984 6.94805 7.56984H6.94893Z",
    fill: "#FF83ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1.40434 13.8153C1.5096 11.4039 2.59115 9.26626 4.41305 7.95752C1.821 9.05048 0.000858307 11.6153 0.000858307 14.6047C0.000858307 18.5871 3.22974 21.816 7.21211 21.816H12.0392C11.0752 21.816 1.05347 21.8765 1.40434 13.8153Z",
    fill: "#38004F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloud_organisation_svg__paint0_linear_1945_697",
    x1: 11.405,
    y1: 11.1074,
    x2: 25.003,
    y2: 0.860283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C38F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloud_organisation_svg__paint1_linear_1945_697",
    x1: 5.32094,
    y1: 24.0783,
    x2: 16.7602,
    y2: 15.4583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F410CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloud_organisation_svg__paint2_linear_1945_697",
    x1: 22.5732,
    y1: 19.4914,
    x2: 38.3535,
    y2: 7.60041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#148C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11F2DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloud_organisation_svg__paint3_linear_1945_697",
    x1: 12.9558,
    y1: 2.53657,
    x2: 27.9169,
    y2: 2.53657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#598CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45E4FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOrganisation);
export default __webpack_public_path__ + "static/media/cloud_organisation.13c46c4736d28cadadc627353b8acde7.svg";
export { ForwardRef as ReactComponent };